import { computed, inject, ref, toRaw } from 'vue'
import { useSize } from '@bigin/hooks'
import { isArray, isBoolean } from '@bigin/utils'
import { checkboxGroupContextKey } from '@bigin/tokens'

import type { ComponentInternalInstance } from 'vue'
import type { CheckboxProps } from '../checkbox'
import type { CheckboxModel } from '../composables'

export const useCheckboxStatus = (
  props: CheckboxProps,
  slots: ComponentInternalInstance['slots'],
  { model }: Pick<CheckboxModel, 'model'>
) => {
  const checkboxGroup = inject(checkboxGroupContextKey, undefined)
  const isFocused = ref(false)
  const isChecked = computed<boolean>(() => {
    const value = model.value
    if (isBoolean(value)) {
      return value
    } else if (isArray(value)) {
      return value.map(toRaw).includes(props.value)
    } else if (value !== null && value !== undefined) {
      return value === props.trueValue
    } else {
      return !!value
    }
  })

  const large = checkboxGroup?.large
  const small = checkboxGroup?.small
  const vertical = checkboxGroup?.vertical

  const checkboxButtonSize = useSize(
    computed(
      () =>
        (large?.value && 'large') ||
        (small?.value && 'small') ||
        checkboxGroup?.size?.value
    ),
    {
      prop: true,
    }
  )
  const checkboxSize = useSize(
    computed(
      () =>
        (large?.value && 'large') ||
        (small?.value && 'small') ||
        checkboxGroup?.size?.value
    )
  )

  const hasOwnLabel = computed<boolean>(() => {
    return !!(slots.default || props.label)
  })

  return {
    checkboxButtonSize,
    isChecked,
    isFocused,
    checkboxSize,
    hasOwnLabel,
    large,
    small,
    vertical,
  }
}

export type CheckboxStatus = ReturnType<typeof useCheckboxStatus>
